import React from "react"
import styled from "styled-components"
import devices from "styles/devices"

interface MortgageExpert {
  avatar: string
  name: string
  title: string
  email: string
}

interface MortgageExpertCardProps {
  mortgageExpert: MortgageExpert
}

const MortgageExpertCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 16px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`

const ExpertAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;

  @media screen and ${devices.bp_lg} {
    width: 82px;
    height: 82px;
  }
`

const ExpertInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

const ExpertName = styled.p`
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  white-space: nowrap;
`

const ExpertTitle = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.8;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
  white-space: nowrap;
`

const ExpertEmail = styled.a`
  font-weight: 500;
  font-size: 12px;
  line-height: 1.8;
  color: ${({ theme }) => theme.colors.brand.primary};
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-decoration-style: solid;
  text-underline-position: from-font;
  margin: 0;
  width: min-content;
  min-width: 100%;
  @media screen and ${devices.bp_lg} {
    font-size: 14px;
  }
`

export const MortgageExpertCardComponent: React.FC<MortgageExpertCardProps> = ({
  mortgageExpert,
}) => {
  return (
    <MortgageExpertCard>
      <ExpertAvatar src={mortgageExpert.avatar} alt={mortgageExpert.name} />
      <ExpertInfo>
        <ExpertName>{mortgageExpert.name}</ExpertName>
        <ExpertTitle>{mortgageExpert.title}</ExpertTitle>
        <ExpertEmail href={`mailto:${mortgageExpert.email}`}>{mortgageExpert.email}</ExpertEmail>
      </ExpertInfo>
    </MortgageExpertCard>
  )
}
